import classes from "./ImagePagination.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const ImagePaginationBox = ({ totalNumber, currentIndex }: any) => {
  let actualIndex = currentIndex;
  if (currentIndex > totalNumber) {
    actualIndex = 1;
  } else if (currentIndex < 1) {
    actualIndex = totalNumber;
  }
  return (
    <div data-testid="property-image-pagination" className={classes.imagePaginationContainer}>
      <p data-testid="image-pagination" className={classes.imagePaginationIndex}>
        {actualIndex}/{totalNumber}
      </p>
    </div>
  );
};

export default wrapperHOC(ImagePaginationBox, {
  componentName: "ImagePaginationBox-Global",
  showForChina: true,
});
